import { render, staticRenderFns } from "./RemoveCourse.vue?vue&type=template&id=7aa677dd&"
import script from "./RemoveCourse.vue?vue&type=script&lang=js&"
export * from "./RemoveCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports